<template>
	<div>
		<div class="menu">
			<el-menu class="el-menu-demo" mode="horizontal">
				<el-menu-item index="1">首页</el-menu-item>
			</el-menu>
		</div>
		<div class="function_item">
			<div class="item_list" id="item1">
				<i class="el-icon-receiving"></i><span>仓库工具</span>
				<div class="contents_li" id="button_item1">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/FBA_shipment.html">
						<el-button>FBA出货</el-button>
					</a>
				</div>
				<div class="contents_li" id="button_item2">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/packing_page.html">
						<el-button>物料装箱</el-button></a>
				</div>
				<div class="contents_li" id="button_item3">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/search_page.html">
						<el-button>物料信息查询</el-button></a>
				</div>
				<div class="contents_li" id="button_item4">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/order_shipment.html">
						<el-button>物料出库</el-button></a>
				</div>
				<div class="contents_li" id="button_item5">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/order_put.html">
						<el-button>物料入库</el-button></a>
				</div>
				<div class="contents_li" id="button_item22">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/change_l">
						<el-button>库存仓位管理</el-button></a>
				</div>
				<div class="contents_li" id="button_item25">
					<a class="contents_a" href="https://kebeidianzi.com/new/#/repository/process" target="_blank">
						<el-button>加工质检</el-button></a>
				</div>
			</div>
			<div class="item_list" id="item2">
				<i class="el-icon-box"></i>工厂物料管理工具:
				<div class="contents_li" id="button_item6">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/stores_requisition.html">
						<el-button>生成领料单</el-button></a>
				</div>
				<div class="contents_li" id="button_item7">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/show_requisition.html">
						<el-button>领料详情</el-button></a>
				</div>
				<div class="contents_li" id="button_item14">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/permanent_store.html">
						<el-button>常备物料管理</el-button></a>
				</div>
				<div class="contents_li" id="button_item201">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/ship">
						<el-button>FBA逾期货件</el-button></a>
				</div>
				<div class="contents_li" id="button_item202">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/packing_out">
						<el-button>领料盘点出库</el-button></a>
				</div>
			</div>
			<div class="item_list" id="item3">
				<i class="el-icon-collection"></i>listing:
				<div class="contents_li" id="button_item8">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/create_msku.html">
						<el-button>新建ASIN</el-button></a>
				</div>
				<div class="contents_li" id="button_item9">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/change_fnsku.html">
						<el-button>换标</el-button></a>
				</div>
				<div class="contents_li" id="button_item10">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/pair_msku.html">
						<el-button>配对</el-button></a>
				</div>
				<div class="contents_li" id="button_item201">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/bsr">
						<el-button>BSR排名</el-button></a>
				</div>
				<div class="contents_li" id="button_item19">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/asin_detail">
						<el-button>前台情况</el-button></a>
				</div>
				<div class="contents_li" id="button_item24">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/rule">
						<el-button>ASIN预警</el-button></a>
				</div>
				<div class="contents_li" id="button_item245">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/search">
						<el-button>关键词</el-button></a>
				</div>

				<div class="contents_li" id="button_item246">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/competitor">
						<el-button>竞品预警</el-button></a>
				</div>
				<div class="contents_li" id="button_item247">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/bsr_d">
						<el-button>BSR对比</el-button></a>
					<!-- <el-button @click="turntopagebsr">BSR对比</el-button> -->
				</div>
			</div>
			<div class="item_list" id="item4">
				<i class="el-icon-copy-document"></i>父体管理:
				<div class="contents_li" id="button_item11">
					<a class="contents_a" href="https://kebeidianzi.com/new/#/new_parent_management">
						<el-button>本地父体管理</el-button></a>
				</div>

				<div class="contents_li" id="button_item111">
					<a class="contents_a" href="https://kebeidianzi.com/new/#/new_parent_child_management">
						<el-button>本地品名管理</el-button></a>
				</div>

				<div class="contents_li" id="button_item112">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/parent_message.html">
						<el-button>父体对比</el-button></a>
				</div>
				<div class="contents_li" id="button_item200">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/auto_update">
						<el-button>自动移入移出</el-button></a>
				</div>
				<div class="contents_li" id="button_item2011">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/parent_calculate">
						<el-button>备货建议</el-button></a>
					<!-- <el-button @click="turntopage3">备货建议</el-button> -->
				</div>
				<div class="contents_li" id="button_item2022">
					<a class="contents_a" href="https://kebeidianzi.com/new/#/salesManagement">
						<el-button>销售项目管理</el-button></a>
				</div>
			</div>
			<div class="item_list" id="item5">
				<i class="el-icon-picture-outline"></i>图片管理:
				<div class="contents_li" id="button_item15">
					<a class="contents_a" href="https://kebeidianzi.com/html/static/templates/upload_image.html">
						<el-button>同步图片</el-button></a>
				</div>
				<div class="contents_li" id="button_item16">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/product">
						<el-button>产品信息</el-button></a>
				</div>
				<div class="contents_li" id="button_item17">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/invoice">
						<el-button>货代发票</el-button></a>
					<!-- <el-button @click="turntopage4">货代发票</el-button> -->
				</div>
				<div class="contents_li" id="button_item18">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/provider">
						<el-button>渠道推荐</el-button></a>
				</div>
				<!-- <div class="contents_li" id="button_item19">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/process">
						<el-button>型号工序</el-button></a>
				</div>
				<div class="contents_li" id="button_item24">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/record">
						<el-button>工时统计</el-button></a>
				</div> -->
			</div>
			<div class="item_list" id="item6">
				<i class="el-icon-shopping-cart-full"></i>项目管理:
				<div class="contents_li" id="button_item15">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/review">
						<el-button>项目评审</el-button></a>
				</div>
				<div class="contents_li" id="button_item16">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/auto_project">
						<el-button>维护项目管理</el-button></a>
				</div>
				<div class="contents_li" id="button_item17">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/comment_m">
						<el-button>评论管理系统</el-button></a>
				</div>
				<div class="contents_li" id="button_item18">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/monitor">
						<el-button>异常监控系统</el-button></a>
				</div>

				<!-- 项目修改1 -->
				<div class="contents_li" id="button_item19">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/sample">
						<el-button>样品监控系统</el-button></a>
					<!-- <el-button @click="turntopage1">样品监控系统</el-button> -->
				</div>
				<!-- <div class="contents_li" id="button_item24">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/sample_manage">
						<el-button>样品样机管理系统</el-button></a>
				</div> -->
			</div>
			<div class="item_list" id="item6">
				<i class="el-icon-shopping-cart-full"></i>生产排序:
				<div class="contents_li" id="button_item15">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/vendor">
						<el-button>供应商管理</el-button></a>
				</div>
				<!-- 项目修改2 -->
				<div class="contents_li" id="button_item16">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/urgent_order">
						<el-button>加急生产单</el-button></a>
					<!-- <el-button @click="turntopage2">加急生产单</el-button> -->
				</div>
				<div class="contents_li" id="button_item17">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/timeout_order">
						<el-button>超期采购单</el-button></a>
				</div>
				<div class="contents_li" id="button_item18">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/application">
						<el-button>我的申请</el-button></a>
				</div>
				<div class="contents_li" id="button_item19">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/check">
						<el-button>我的审核</el-button></a>
				</div>
				<div class="contents_li" id="button_item24">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/statistic">
						<el-button>超期情况</el-button></a>
				</div>
				<div class="contents_li" id="button_item245">
					<a class="contents_a" href="https://kebeidianzi.com/dashboard/double-check">
						<el-button>收货核对</el-button></a>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

export default {
	methods: {
		turntopage1() {  // 改用普通函数
			// this.$router.push({ name: 'bsr_d' })   //原有的bsr页面
			this.$router.push({ name: 'sample' })
		},
		turntopage2() {  // 改用普通函数
			// this.$router.push({ name: 'bsr_d' })   //原有的bsr页面
			this.$router.push({ name: 'urgent_order' })
		},
		turntopagebsr() {  // 改用普通函数
			// this.$router.push({ name: 'bsr_d' })   //原有的bsr页面
			this.$router.push({ name: 'bsr_d' })
		},
		turntopage3() {
			this.$router.push({ name: 'parent_calculate' })
		},

		turntopage4() {
			this.$router.push({ name: 'invoice' })
		},

	}
}
</script>


<style>
.function_item {
	margin-top: 50px;
}

.item_list {
	width: 90%;
	height: 105px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	background-color: white;
	position: relative;
	top: 0;
	bottom: 0;
}

.contents_li {
	width: 100px;
	height: 40px;
}

.contents_e {
	padding: 10px 0;
	float: left;
	width: 100px;
	height: 20px;
	color: black;
	background-color: white;
	/*将按钮背景设置为红色，字体设置为白*/
	border: none;
	outline: none;
	/*取消边框和外边框将按钮边框去掉*/
	text-align: center;
}

#item1 {
	margin: 10px 0px 0px 50px;
}

#button_item1 {
	margin: 10px 0px 0px 50px;
}

#button_item2 {
	margin: -41px 0px 0px 250px;
}

#button_item3 {
	margin: -41px 0px 0px 450px;
}

#button_item4 {
	margin: -41px 0px 0px 650px;
}

#button_item5 {
	margin: -41px 0px 0px 850px;
}

#button_item15 {
	margin: -41px 0px 0px 850px;
}

#item2 {
	margin: 10px 0px 0px 50px;
}

#button_item6 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}

#button_item7 {
	position: absolute;
	margin: 10px 0px 0px 250px;
}

#button_item14 {
	position: absolute;
	margin: 10px 0px 0px 450px;
}

#button_item22 {
	position: absolute;
	margin: -41px 0px 0px 1050px;
}

#button_item25 {
	position: absolute;
	margin: -41px 0px 0px 1250px;
}

#button_item26 {
	position: absolute;
	margin: -41px 0px 0px 1450px;
}

#item3 {
	margin: 10px 0px 0px 50px;
}

#button_item8 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}

#button_item9 {
	position: absolute;
	margin: 10px 0px 0px 250px;
}

#button_item10 {
	position: absolute;
	margin: 10px 0px 0px 450px;
}

#item4 {
	margin: 10px 0px 0px 50px;
}

#button_item11 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}

#button_item111 {
	position: absolute;
	margin: 10px 0px 0px 250px;
}




#button_item12 {
	position: absolute;
	margin: 10px 0px 0px 250px;
}



#button_item112 {
	position: absolute;
	margin: 10px 0px 0px 450px;
}

#item5 {
	margin: 10px 0px 0px 50px;
}

#button_item13 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}

#item6 {
	margin: 10px 0px 0px 50px;
}

#button_item17 {
	position: absolute;
	margin: 10px 0px 0px 450px;
}

#button_item18 {
	position: absolute;
	margin: 10px 0px 0px 650px;
}

#button_item19 {
	position: absolute;
	margin: 10px 0px 0px 850px;
}

#button_item20 {
	position: absolute;
	margin: 10px 0px 0px 450px;
}

#button_item200 {
	position: absolute;
	margin: 10px 0px 0px 650px;
}

#button_item201 {
	position: absolute;
	margin: 10px 0px 0px 650px;
}

#button_item2011 {
	position: absolute;
	margin: 10px 0px 0px 850px;
}

#button_item202 {
	position: absolute;
	margin: 10px 0px 0px 850px;
}

#button_item2022 {
	position: absolute;
	margin: 10px 0px 0px 1050px;
}


#button_item24 {
	position: absolute;
	margin: 10px 0px 0px 1050px;
}

#button_item245 {
	position: absolute;
	margin: 10px 0px 0px 1250px;
}

#button_item246 {
	position: absolute;
	margin: 10px 0px 0px 1400px;
}

#button_item247 {
	position: absolute;
	margin: 10px 0px 0px 1550px;
}

#button_item16 {
	position: absolute;
	margin: 10px 0px 0px 250px;
}

#button_item15 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}

#button_itemvue1 {
	position: absolute;
	margin: 10px 0px 0px 50px;
}


#itemvue1 {
	margin: 10px 0px 0px 50px;
}
</style>